import React, {useState, useEffect, Fragment} from "react";
import {connect} from "react-redux"
import {Spinner} from "react-bootstrap";
import moment from "moment";
import NumberFormat from 'react-number-format';
import {Accordion, Button} from "react-bootstrap";


const OrdersBase = (props)=> {

    const [asData, setAsData] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [orders, setOrders] = useState([])


    useEffect(() => {

        fetchOrders()

    }, [])


    const fetchOrders = ()=>{

        axios.get('/Api/customer/orders')
            .then(result=>{
                (result.data)?setOrders(result.data):null;
                (result.data.length>0)?setAsData(true):null;
                setIsLoading(false)
                console.log(result.data)
            }).catch(err=>console.log(err))
    }

    const renderColorState=(color)=>{
        switch(color){
            case 'blue':
                return  "badge badge-info badge-pill text-light p-1"
            case 'red':
                return  "badge badge-danger badge-pill text-light p-1"
            case 'green':
                return  "badge badge-success badge-pill text-light p-1"
            default :
                return "badge badge-primary badge-pill text-light p-1"
        }
    }

    const renderSub=(item,index)=>{

        return(
            <div key={index} className={"d-flex flex-row justify-content-end align-items-center  border-top border-primary py-3 pl-6"} style={{"paddingLeft": "40px"}}>
            <div className={"font-weight-bold"}><i className="fas fa-chevron-circle-right text-primary"></i> {item.quantity} X {item.name} </div>
            <div className={"ml-3"}> au prix unitaire de {item.unit_price}€   <span className={"text-mutted"}><i className="fas fa-arrow-right"></i></span></div>
                <div className={"badge badge-primary d-flex justify-self-end p-2"} style={{"marginLeft": "40px", "right":"200px"}}>{item.total_price_gross}€</div>
            </div>
        )
    }


    const renderItem = (order,index)=>{
        let display = false;
        return(
            <Accordion key={index}>
                <table className={"table table-bordered ueColorBase shadow-sm"}>
                <tbody>
                    <tr>
                        <td>
                            <Accordion.Toggle as={Button} variant="link" eventKey={order.reference+index}>
                            {moment(order.created_at).format("MM/DD/YYYY h:m") }
                            </Accordion.Toggle>
                        </td>
                        <td className={"font-weight-bold"}><span style={{"fontFamily":"monospace"}}>{order.reference}</span></td>
                        <td>{(order.billing_reason=='subscription_create')?'Abonnement':'transaction'}</td>
                        <td>
                            <span className={renderColorState(order.comstate.color)}>
                            {order.comstate.name}
                            </span>
                        </td>
                        <td>
                            <NumberFormat value={order.total} displayType={'text'} thousandSeparator={' '} decimalScale={2} suffix={'€'} />
                        </td>
                        <td className={"text-center"}>
                            <a className="btn btn-sm btn-outline-primary m-2"
                               href={order.order_pdf}>
                                <i className="far fa-file-pdf"></i>
                            </a>
                        </td>
                    </tr>
                    <tr className={"p-0"}>
                        <td colSpan={7} className={"p-0"}>
                        <Accordion.Collapse eventKey={order.reference+index}>
                            <div className={'text-dark'}>
                                {
                                    order.products.map((item2,index)=>{ return renderSub(item2,index)})
                                }
                            </div>
                        </Accordion.Collapse>
                        </td>
                    </tr>
                </tbody>
                </table>
            </Accordion>
        )
    }

    return (
        <div className={"card ueThemeBackground ueColorBase"}>
            <div className={"card-body"}>
                <div className={"row"}>
                    <div className="col-12 col-lg-8">
                        <h3 className={"card-title my-4 font-weight-light"}><i className="bi bi-cart-check text-primary"/> Commandes</h3>

                        {
                            (asData)?
                                <div >
                                {
                                    (orders.length>0)?
                                        orders.map((item,index)=>{
                                            return renderItem(item,index) ;
                                        })
                                        :null
                                }
                                </div>
                                : <div className="table_body">
                                {
                                    (isLoading)?
                                        <div className={"text-center"}>
                                            <div className="text-center my-2">
                                                <Spinner animation="border" size={'md'}/>
                                            </div>
                                        </div>
                                        :<div className={"text-center"}><h6><i className="bi bi-exclamation-diamond text-primary"></i><br/>Pas de commande disponible pour votre compte</h6></div>
                                }
                                </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        updateStructureInfo: (e) => dispatch( {type: 'UPDATE_STRUCTURE_INFO', data:e}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(OrdersBase);





